export const getCurrentDate = (sep, date = new Date()) =>
  date.getDate() + sep + (date.getMonth() + 1) + sep + date.getFullYear();

export const getCurrentTime = () => new Date().toLocaleTimeString();
